import { KOGMediaQuery } from "@/main/services/utilsLayout";
import styled, { css, keyframes } from "styled-components";

export const AreaButton = styled.div`
	position: sticky;
	display: flex;
	top: 4rem;
	margin: -3rem 0 -0.4rem auto;
	z-index: 10;
	gap: 1rem;

	> button {
		margin: 1rem 0;
	}

	@media (max-width: 560px) {
		margin: 0 0 1rem auto;
	}
`;

export const ContainerSection = styled.div`
	background-color: ${({ theme }) => theme.pantone656C};
	padding: 1rem;
	border-radius: 6px;
	margin: 0 0 2rem 0;
`;

export const RowFlex = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: flex-start;
	gap: 1rem;
	width: 100%;
`;
export const RowHeaderTextCenter = styled.div`
	text-align: center;
`;
export const RowHeaderTextEnd = styled.div`
	text-align: end;
`;
export const RowHeaderTextLeft = styled.div`
	text-align: start;
`;
interface ISpinnerLoadingProps {
	size?: "xsmall" | "small" | "medium" | "large";
	customSize?: string;
	noMargin?: boolean;
}
const SIZE_SPINNER = {
	xsmall: "16px",
	small: "20px",
	medium: "30px",
	large: "40px",
};

export const SpinnerLoading = styled.div<ISpinnerLoadingProps>`
	border: 3px solid ${({ theme }) => theme.grayDark};
	border-left-color: ${({ theme }) => theme.pantone2726C};
	border-radius: 50%;
	width: ${({ size, customSize }) => customSize || SIZE_SPINNER[size || "small"]};
	height: ${({ size, customSize }) => customSize || SIZE_SPINNER[size || "small"]};
	animation: spin 1s linear infinite;
	margin: ${({ noMargin }) => (noMargin ? "0" : "0 auto;")};

	@keyframes spin {
		to {
			transform: rotate(360deg);
		}
	}
`;
// Style Components INFO
export const HeaderSection = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	margin-bottom: 1rem;
`;

export const HeaderText = styled.h4`
	color: #000;
	font-size: 1rem;
	font-weight: bold;
	margin: 0;
`;

// Skeleton loading
const shimmer = keyframes`
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: 200px 0;
  }
`;
interface ISkeletonLoadingProps {
	$width?: string;
	$height?: string;
	$forceWidth?: string;
	$margin?: string;
}

export const SkeletonLoading = styled.div<ISkeletonLoadingProps>`
	height: ${({ $height }) => $height || "20px"};
	width: ${({ $forceWidth }) => $forceWidth || "100%"};
	max-width: ${({ $width }) => $width || "100%"};
	margin: ${({ $margin }) => $margin || "0"};
	background-color: #e0e0e0;
	border-radius: 4px;
	position: relative;

	&::after {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		width: ${({ $width }) => $width || "100%"};
		height: 100%;
		background: linear-gradient(to right, transparent, #f0f0f0, transparent);
		animation: ${shimmer} 1.5s infinite;
	}
`;

export const TextEllipsis = styled.div`
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

interface IHideDivProps {
	$show?: boolean;
}
export const HideDiv = styled.div<IHideDivProps>`
	display: ${({ $show }) => ($show ? "block" : "none")};
`;

interface IKOGAreaButtonsProps {
	$isRegisterScreen?: boolean;
}
export const KOGAreaButtons = styled.div<IKOGAreaButtonsProps>`
	display: flex;
	justify-content: flex-end;
	gap: 1rem;

	> button {
		margin: 0;
		${({ $isRegisterScreen }) =>
			$isRegisterScreen &&
			css`
				max-width: 200px;
			`}
	}

	${({ theme }) =>
		KOGMediaQuery({
			breakpoint: theme.breakpoints.mobile,
			includeOrientation: false,
			styles: css`
				flex-direction: column;

				> button {
					width: 100%;
					max-width: 100%;
					margin: 0;
				}
			`,
		})}
`;
export const KOGAreaButtonsModal = styled.div`
	display: flex;
	justify-content: center;
	gap: 1rem;

	> button {
		margin: 0;
	}

	${({ theme }) =>
		KOGMediaQuery({
			breakpoint: theme.breakpoints.mobile,
			includeOrientation: false,
			styles: css`
				flex-direction: column;

				> button {
					width: 100%;
					max-width: 100%;
					margin: 0;
				}
			`,
		})}
`;

export const ContainerSwitch = styled.div`
	.Mui-disabled {
		&:hover {
			cursor: not-allowed;
		}

		.MuiIconButton-label {
			color: ${({ theme }) => theme.disabled};
		}
	}
`;

export const GridWrapper = styled.div`
	/* Header selecionado */
	&[data-selected-col="0"] th:nth-child(3),
	&[data-selected-col="1"] th:nth-child(4),
	&[data-selected-col="2"] th:nth-child(5),
	&[data-selected-col="3"] th:nth-child(6) {
		background-color: ${({ theme }) => theme.pantone656C};
	}

	/* Células do corpo selecionadas */
	&[data-selected-col="0"] td:nth-child(3),
	&[data-selected-col="1"] td:nth-child(4),
	&[data-selected-col="2"] td:nth-child(5),
	&[data-selected-col="3"] td:nth-child(6) {
		background-color: ${({ theme }) => theme.pantone656C};
	}

	/* Input branco dentro de célula selecionada */
	&[data-selected-col="0"] td:nth-child(3) .MuiInputBase-root,
	&[data-selected-col="1"] td:nth-child(4) .MuiInputBase-root,
	&[data-selected-col="2"] td:nth-child(5) .MuiInputBase-root,
	&[data-selected-col="3"] td:nth-child(6) .MuiInputBase-root {
		background-color: white;
	}
`;

export const KogTextResponsive = styled.div`
	display: block;

	p,
	span,
	strong,
	b,
	h1,
	h2,
	h3,
	h4,
	h5,
	h6,
	div {
		display: block;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		max-width: 100%;
		width: fit-content;
		min-width: 0;
	}
`;
